import humanize from 'underscore.string/humanize';

angular.module('filters').filter('humanize', ["$filter", function($filter) {
  return function(data, toLowerCase) {
    var str;
    str = humanize(data);
    if (toLowerCase) {
      return $filter('lowercase')(str);
    } else {
      return str;
    }
  };
}]);
